import { Link } from "react-router-dom";

function Shell({ children }) {
  return (
    <div className="bg-gray-100 min-h-screen">
      <header className="bg-white py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900">Nightdrift</h1>
          <h1 className="text-medium font-thin text-gray-900">Drift off peacefully.</h1>
          <nav className="mt-2 text-sm">
            <Link to="/" className="text-blue-500 hover:text-blue-600">Home</Link>
            {" · "}
            <Link to="/browdesigner" className="text-blue-500 hover:text-blue-600">Brow Designer</Link>
            {" · "}
            <Link to="/nightdrift" className="text-blue-500 hover:text-blue-600">Nightdrift</Link>
            {" · "}
            <Link to="/nightdrift/support" className="text-blue-500 hover:text-blue-600">Support</Link>
            {" · "}
            <Link to="/nightdrift/privacypolicy" className="text-blue-500 hover:text-blue-600">Privacy Policy</Link>
            {" · "}
            <Link to="/nightdrift/terms" className="text-blue-500 hover:text-blue-600">Terms of Use</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        {children}
      </main>

      <footer className="bg-white py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-gray-500 text-sm text-center mb-2">
            <Link to="/" className="text-blue-500 hover:text-blue-600">Home</Link>
            {" · "}
            <Link to="/browdesigner" className="text-blue-500 hover:text-blue-600">Brow Designer</Link>
            {" · "}
            <Link to="/nightdrift" className="text-blue-500 hover:text-blue-600">Nightdrift</Link>
            {" · "}
            <Link to="/nightdrift/support" className="text-blue-500 hover:text-blue-600">Support</Link>
            {" · "}
            <Link to="/nightdrift/privacypolicy" className="text-blue-500 hover:text-blue-600">Privacy Policy</Link>
            {" · "}
            <Link to="/nightdrift/terms" className="text-blue-500 hover:text-blue-600">Terms of Use</Link>
          </p>
          <p className="text-gray-500 text-sm text-center">© 2023 SADWARE INCORPOATED. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Shell;
